import React from 'react';
import { Source, Layer } from 'shared/map-exports';
import { useMapLayersState } from 'state/useMapLayersState';
import { MapBaseLayerNames } from 'features/mapping/mapping.constants';
import { BELOW_STREETS_LAYER_ID } from 'features/mapping/styles';
import { usePlanetLabsRasterTilesets } from '../hooks';

export const PlanetLabsBasemapLayer: React.FC = () => {
  const { mapBaseLayer } = useMapLayersState();
  const tilesets = usePlanetLabsRasterTilesets();

  const isSatellite = mapBaseLayer === MapBaseLayerNames.SATELLITE;
  const [tileset] = tilesets;

  if (!isSatellite || !tileset) {
    return null;
  }

  return (
    <Source id="planet-labs-basemap" type="raster" url={tileset.tilejsonUrl}>
      <Layer
        id="planet-labs-basemap-layer"
        type="raster"
        beforeId={BELOW_STREETS_LAYER_ID}
      />
    </Source>
  );
};
